<template>
  <div class="subproject-item width-percent-100 h80 bg-white flex-start-center border-box ph12 yxtbizf-br-4">
    <yxtf-image
      class="subproject-img"
      :src="data.imageUrl"
      fit="cover" />
    <div class="ml16 col-flex-1 over-hidden">
      <h3 class="font-size-16 c-26 ellipsis weight-400">{{ data.name }}</h3>
      <p v-if="data.startTime && data.endTime" class="mt9 text-8c font-size-11">
        {{ formatTime(data.startTime) }} ~ {{ formatTime(data.endTime) }}
      </p>
      <p v-else class="mt9 text-8c font-size-11">{{ $t('pc_biz_lbl_nolimittime'/* 不限时间 */) }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: ()=>({})
    }
  },
  methods: {
    addTime0(n) {
      return n >= 10 ? n : '0' + n;
    },
    formatTime(date) {
      if (date) {
        date = new Date(date.replace(/-/g, '/'));
      } else {
        return this.$t('pc_biz_lbl_nolimittime');
      }
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      return (
        [year, month, day].map(this.addTime0).join('-') +
        ' ' +
        [hour, minute].map(this.addTime0).join(':')
      );
    }
  }
};
</script>
